import { render, staticRenderFns } from "./steelBoxDehumidifier.vue?vue&type=template&id=9e89615e&scoped=true"
import script from "./steelBoxDehumidifier.vue?vue&type=script&lang=js"
export * from "./steelBoxDehumidifier.vue?vue&type=script&lang=js"
import style0 from "./steelBoxDehumidifier.vue?vue&type=style&index=0&id=9e89615e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e89615e",
  null
  
)

export default component.exports